import { useCallback, useEffect, useRef, useState } from 'react'

const useCloseDropdown = () => {
  const [isHidden, setIsHidden] = useState(false)
  const refForDropdown = useRef(null)

  const closeDropdownWhenUsingScroll = useCallback(
    (e) => {
      if (
        refForDropdown.current &&
        !refForDropdown.current.contains(e.target) &&
        isHidden
      ) {
        setIsHidden(false)
        return
      }
      if (!refForDropdown.current && isHidden) {
        setIsHidden(false)
      }
    },
    [isHidden],
  )

  useEffect(() => {
    if (isHidden) {
      document.addEventListener('wheel', closeDropdownWhenUsingScroll)
      return () => {
        document.removeEventListener('wheel', closeDropdownWhenUsingScroll)
      }
    }
  }, [isHidden, closeDropdownWhenUsingScroll])

  return [isHidden, setIsHidden, refForDropdown]
}

export default useCloseDropdown
